<template>
  <scrollbar class="products-list-wrap" :class="{ 'light-theme': light }" id="products-list-wrap">
    <ul class="list-unstyled mb-0">
      <template v-for="(catalog, cid) of catalogs">
        <a-divider orientation="left" v-if="catalog[0].meta.catalog!='home'" :key="cid">{{ $t('sidepage.catalog.' + catalog[0].meta.catalog) }}</a-divider>
        <template v-for="(item, idx) of catalog">
          <products-list-sub
            :key="idx"
            :item="item"
            :active-menu="activeMenu"
            :popover-align="popoverAlign"
            :get-label="getLabel"
            :show-menu="showMenu"
            :light="light"
            @route-change="$emit('route-change')" />
        </template>
      </template>
    </ul>
  </scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import * as R from 'ramda'
import { menusConfig } from '@/router/routes'
import { hasPermission } from '@/utils/auth'
import ProductsListSub from './Sub'

export default {
  name: 'ProductsList',
  components: {
    ProductsListSub,
  },
  props: {
    activeMenu: Object,
    popoverAlign: Object,
  },
  data () {
    return {
      menuitems: menusConfig,
    }
  },
  computed: {
    ...mapGetters(['theme', 'userInfo']),
    light () {
      return this.theme === 'light'
    },
    menus () {
      const ret = this.menuitems.filter(m1item => {
        let flag = false
        if (this.showMenu(m1item)) {
          if (m1item.menus) {
            m1item.menus.forEach(m2item => {
              if (this.showMenu(m2item)) {
                if (m2item.submenus) {
                  m2item.submenus.forEach(m3item => {
                    if (this.showMenu(m3item)) {
                      flag = true
                    }
                  })
                } else {
                  flag = true
                }
              }
            })
          } else {
            flag = true
          }
        }
        return flag
      })
      return ret
    },
    catalogs () {
      const grouped = this.menus.reduce(function (result, current) {
        (result[current.meta.catalog] = result[current.meta.catalog] || []).push(current)
        return result
      }, {})
      var clone = {}
      for (const key in grouped) {
        const catalog_title = this.$t('catalog.' + key)
        clone[catalog_title] = []
        const modules = grouped[key]
        for (const module of modules) {
          const menus = []
          // 单独处理首页
          if (module.menu) {
            // Add module
            clone[catalog_title].push({
              index: module.index,
              title: module.meta?.label,
              icon: module.meta?.icon,
              path: (process.env.VUE_APP_BASE_URL || '') + module.menu.path,
              permission: module.meta?.permission,
            })
            continue
          }
          for (const menu of module.menus) {
            const submenus = []
            if (menu.submenus) {
              for (const submenu of menu.submenus) {
                let path = submenu.path
                if (process.env.VUE_APP_BASE_URL) {
                  if (module.meta.catalog !== 'mlops' && module.meta.label !== '费用中心') {
                    path = process.env.VUE_APP_BASE_URL + path
                  }
                }
                submenus.push({
                  title: submenu.meta?.label,
                  icon: submenu.meta?.icon,
                  path: path,
                  permission: submenu.meta?.permission,
                  adminOnly: submenu.meta?.adminOnly,
                })
              }
            }
            // Add menu
            menus.push({
              title: menu.meta?.label,
              type: 'group',
              icon: menu.meta?.icon,
              children: submenus,
              permission: menu.meta?.permission,
              adminOnly: menu.meta?.adminOnly,
            })
          }
          // Add module
          clone[catalog_title].push({
            index: module.index,
            title: module.meta?.label,
            icon: module.meta?.icon,
            children: menus,
            permission: module.meta?.permission,
          })
        }
      }
      window.SHOW_ROUTES && console.log(JSON.stringify(clone))
      const ret = Object.values(grouped)
      return ret
    },
  },
  methods: {
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    getMenuHidden (menu) {
      if (!R.isNil(menu.meta.hidden)) {
        if (R.is(Function, menu.meta.hidden)) {
          return menu.meta.hidden(this.userInfo)
        }
        return menu.meta.hidden
      }
      if (!R.isNil(menu.meta.invisible)) {
        if (R.is(Function, menu.meta.invisible)) {
          return menu.meta.invisible(this.userInfo)
        }
        return menu.meta.invisible
      }
      return false
    },
    showMenu (item) {
      const hidden = this.getMenuHidden(item)
      if (R.isNil(item.meta.permission) || R.isEmpty(item.meta.permission)) {
        if (item.meta.roles) {
          return !hidden && R.intersection(this.userInfo.roles, item.meta.roles).length > 0
        }
        return !hidden && true
      }
      return !hidden && hasPermission({ key: item.meta.permission })
    },
  },
}
</script>

<style lang="less">
@import "../../styles/less/theme";
.list-unstyled{
  padding-top: 20px;
}
.products-list-wrap .ant-divider.ant-divider-horizontal.ant-divider-with-text-left {
  margin: 4px;
  padding: 8px 0;
  border-top: 1px solid @sidebar-dark-bg-color;
  font-size: 13px;
  color: #6c707e;
  font-weight: 400;
}
.products-list-wrap {
  // margin-top: 8px;
  height: 100%;
  background-color: @sidebar-dark-bg-color;
  .scrollbar-wrap {
    overflow-x: hidden;
  }
  .ant-divider-horizontal.divider-with-text-left {
    margin: 0;
    border-top: 1px solid @sidebar-dark-bg-color;
    font-size: 14px;
    color: @title-body-color;
    font-weight: unset;
  }
  &.light-theme {
    background-color: @sidebar-light-bg-color;
    .l1-menu-item {
      > a {
        color: @sidebar-light-text-color;
      }
      &:hover {
        // background-color: @primary-1;
        background: rgba(95,120,255,0.1);
        margin: 0 10px;
        > a {
          color: @primary-color!important;
        }
      }
      &.active {
        // background-color: @primary-1 !important;
        > a {
          color: @primary-color;
        }
      }
      &.ant-popover-open {
       // background-color: @primary-1;
        background: rgba(95,120,255,0.1);
        margin: 0 10px;
        > a {
          color: @primary-color!important;
        }
      }
      .l1-menu-item-right-icon {
        color: @sidebar-light-text-color!important;
      }
    }
  }
}
.l1-menu-item {
  > a {
    font-size:15px;
    height: 36px;
    color: @title-important-color;
    font-weight: 500;
    margin: 0 10px 6px;
    line-height: 16px;
  }
  .l1-menu-item-icon {
    width: 16px;
    height: 16px;
    text-align: center;
    margin-right: 12px;
    margin-left: 12px;
    > i {
      font-size: 16px;
      width: 16px;
      height: 16px;
    }
  }
  .l1-menu-item-right-icon {
    width: 26px;
    text-align: left;
    > i {
      font-size: 12px;
    }
  }
  &.active {
    // background-color: @primary-7 !important;
    > a {
      color: @sidebar-light-active-text-color;
      border-radius: 4px;
      margin: 0 10px 8px;
      border:1px solid  rgba(93,120,255,0.5);
      background: rgba(93,120,254,0.1);
    }
  }
  &:hover {
    background-color: @sidebar-hover-bg-color;
    > a {
      color: @sidebar-dark-hover-text-color!important;
    }
  }
  &.ant-popover-open {
    //background-color: @sidebar-hover-bg-color;
    //background: rgba(95,120,255,0.1);
    > a {
      color: @sidebar-dark-hover-text-color!important;
      background: rgba(95,120,255,0.1);
      background-position: 10px center;
    }
  }
  .l1-menu-item-right-icon {
    color: @sidebar-light-text-color!important;
  }
}
</style>
